import { GetterTree } from 'vuex';
import { Lesson, LessonsState } from '@/store/lessons/types';
import { RootState } from '@/store/types';

const getters : GetterTree<LessonsState, RootState> = {
  findLessonByScheduleId: (state) => (scheduleId: string): Lesson|undefined => {
    return state.lessons.find((lesson) => lesson.scheduleId === scheduleId)
  },
};

export default getters;
